import React from 'react';

const ScreenHeaderLoader = () => {
  return (
    <div className={'screen-header loader'}>
      <div className={'screen-tabs-row'}>
        <div className={'screen-tabs'}>
          <div className={'screen-tab active'}>
            <div className={'screen-tab-label loader-block'} />
            <div className={'screen-tab-count loader-block'} />
          </div>
        </div>
        <div className={'screen-filters'}>
          <div className={'filters'}>
            <div className={'pinned-filters'}>
              <div className={'filter-item'}>
                <div className={'filter-item-btn loader-block'} />
              </div>
              <div className={'filter-item'}>
                <div className={'filter-item-btn loader-block'} />
              </div>
              <div className={'filter-item'}>
                <div className={'filter-item-btn loader-block'} />
              </div>
              <div className={'filter-item'}>
                <div className={'filter-item-btn short loader-block'} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScreenHeaderLoader;
